import { render } from "./MdTooltip.vue?vue&type=template&id=3040f92a&scoped=true&ts=true"
import script from "./MdTooltip.vue?vue&type=script&lang=ts"
export * from "./MdTooltip.vue?vue&type=script&lang=ts"

import "./MdTooltip.vue?vue&type=style&index=0&id=3040f92a&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3040f92a"]])

export default __exports__